export const WORKER_PROFILE_MODAL_MESSAGES = {
  NO_APP: {
    title: 'Невозможно сформировать справку',
    text: 'Исполнитель не зарегистрирован в приложении',
  },
  FNS_STATUS: {
    title: 'Невозможно сформировать справку',
    text: 'Исполнитель не подключен к приложению "Мой налог"',
  },
  ERROR_DOWNLOAD_REFERENCE: {
    title: 'Ошибка при загрузке справки',
    text: 'Не удалось сформировать справку. Попробуй позднее.',
  },
  NO_APP_CONTRACT: {
    title: 'Невозможно создать договор',
    text: 'Исполнитель не зарегистрирован в приложении',
  },
  ERROR_CREATE_CONTRACT: {
    title: 'Ошибка при создании договора',
    text: 'С данным исполнителем уже есть действующий договор.',
  },
  ERROR_CREATE_CONTRACTS: {
    title: 'Ошибка при создании договора',
    text: 'С данным исполнителем уже есть действующие договоры.',
  },
  FNS_STATUS_CONTRACT: {
    title: 'Невозможно создать договор',
    text: 'Исполнитель не подключен к приложению "Мой налог"',
  },
  STOPLIST_CONTRACT: {
    title: 'Невозможно создать договор',
    text: 'Исполнитель в стоп-листе.',
  },
} as const;
